import type { SearchApiDocumentMySE } from '../../../../api/SearchApi';

export function highlight(term: string, word: string, opening = '<span class="highlight">', closing = '</span>'): string {

    const values = term
      .split(' ')
      .map(str => escapeRegexp(str))
      .join('|');

    // g - global = match any occurance
    // i - case insensitive,
    // u - unicode, excapeRegexp returns escaped unicode points
    return word.replace(new RegExp(values, 'gui'), function (x) {

        return opening + x + closing;
    });
}

export function buildUrl(url: string, doc: SearchApiDocumentMySE): string {
    let linkUrl = url;
    if(url?.includes('{')){
      let match;
      while ((match = (/\{.*?}/).exec(linkUrl)) != null) {
        let urlFieldName = match[0].replace('{', '');
        urlFieldName = urlFieldName.replace('}', '');

        if (doc.hasOwnProperty(urlFieldName)) {
          const value = doc[urlFieldName];
          linkUrl = linkUrl.replace(match[0], value);
        }
      }
    }
    if(linkUrl !== undefined){
      if(linkUrl.includes('highlight')){
        linkUrl = linkUrl.replace('<span class="highlight">', '');
        linkUrl = linkUrl.replace('</span>', '');
      }
    }
    return linkUrl;
}

export function downloadFile(fileUrl: string, fileName: string): void {
    fetch(fileUrl).then(function(t) {
        return t.blob().then((b)=>{
            const anchor = document.createElement('a');
            anchor.href = URL.createObjectURL(b);
            anchor.setAttribute('download', fileName);
            anchor.click();
            anchor.remove();
        });
    });
}

export function downloadFileBlob(data: any, fileName: string): void { //eslint-disable-line @typescript-eslint/no-explicit-any
    const href = URL.createObjectURL(data);
    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
}

export function escapeRegexp(input: string): string {
    return Array.from(input)
      .map(char => `\\u{${char.charCodeAt(0).toString(16)}}`)
      .join('');
}

export function sanitizeHTML(input: string): string {
    const strippedInput = input.replace(/<script.*?>.*?<\/script>/gi, '')
      .replace(/<body.*?>/gi, '')
      .replace(/ on\w+=".*?"/gi, '')
      .replace(/<%.*?%>/g, '');

    const doc = new DOMParser().parseFromString(strippedInput, 'text/html');

    const allowedTags = ['span'];

    doc.body.querySelectorAll('*').forEach(el => {
        if (!allowedTags.includes(el.tagName.toLowerCase()) || el.getAttribute('class') !== 'highlight') {
          el.replaceWith(el.textContent || '');
        }
    });

    const sanitizedHTML = doc.body.innerHTML;

    return sanitizedHTML;
}
